export enum CategoriaProduto {
    Tradicional = 1,
    Flex = 2,
    Incentivo = 3,
    Wallet = 4,
    IncentivoPlus = 5,
    TradicionalPlus = 6,
    SeuValeLog = 7,
}
